import { useEffect, useState } from "react";
import "./BackToTopButton.scss";

const SCROLL_SHOW_THRESHOLD = 400;

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > SCROLL_SHOW_THRESHOLD);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      className="back-to-top-button"
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <svg
        width="14"
        height="8"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.64645 0.646447C5.84171 0.451184 6.15829 0.451184 6.35355 0.646447L11.3536 5.64645C11.5488 5.84171 11.5488 6.15829 11.3536 6.35355C11.1583 6.54882 10.8417 6.54882 10.6464 6.35355L6 1.70711L1.35355 6.35355C1.15829 6.54882 0.841709 6.54882 0.646447 6.35355C0.451184 6.15829 0.451184 5.84171 0.646447 5.64645L5.64645 0.646447Z"
          fill="white"
        />
      </svg>
    </button>
  );
};

export default BackToTopButton;
